<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      width="500"
      persistent>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Ubah Data Config Radius
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="reset()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="pt-2">
          <ValidationObserver ref="form">
            <v-form>
              <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Lokasi Kantor
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 70%;'"
                  dense
                  outlined
                  placeholder="Ex. John Doe"
                  color="#00ACC1"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <v-row>
                <v-col cols="12" md="6" sm="6" class="py-0">
                  <ValidationProvider name="latitude" rules="required" v-slot="{ errors }">
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Koordinat Latitude
                    </p>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      type="number"
                      @focus="$event.target.select()"
                      dense
                      outlined
                      placeholder="Ex. -7.7553924"
                      color="#00ACC1"
                      v-model="form.latitude"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="6" sm="6" class="py-0">
                  <ValidationProvider name="longitude" rules="required" v-slot="{ errors }">
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Koordinat longitude
                    </p>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      type="number"
                      @focus="$event.target.select()"
                      dense
                      outlined
                      placeholder="Ex. 110.6038197"
                      color="#00ACC1"
                      v-model="form.longitude"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <ValidationProvider name="attended_range" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Jarak Absen (Radius)
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 35%;'"
                  type="number"
                  @focus="$event.target.select()"
                  suffix="M"
                  dense
                  outlined
                  placeholder="Ex. 20"
                  color="#00ACC1"
                  v-model="form.attended_range"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-card flat style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="9" class="d-flex align-center">
                <div v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #2196f333;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="reset(selected.row[0])">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  color="#00ACC1"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search.name"
                  @click:clear="search.name = ''; fetch();"
                  v-on:keyup.enter="fetch()">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid text-capitalize"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '300px' : '228px'})`"
            fixed-header
            show-select
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="headers"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick" 
            @toggle-select-all="handleToggleAll($event)"
            hide-default-footer>
            <template v-slot:[`item.attended_range`]="{ item }">
              {{ item.attended_range }} M
            </template>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)"
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          snackbar: false
        },
        search: {
          name: ''
        },
        selected: {
          row: []
        },
        options: {},
        headers: [],
        list: [],
        pagination: {},
        limit: 20,
        form: {
          id: '',
          name: '',
          latitude: '',
          longitude: '',
          attended_range: ''
        },
        process: {
          load: false,
          form: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      options: {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll(event) {
        if (!event.value) this.selected.row = []
      },
      async fetch(pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          search: this.search.name
        }

        await get(`admin/office`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.headers = [
              {
                text: 'Lokasi Kantor',
                width: '200px',
                value: 'name'
              },
              {
                text: 'Koordinat Latitude',
                width: '200px',
                value: 'latitude'
              },
              {
                text: 'Koordinat Longitude',
                width: '200px',
                value: 'longitude'
              },
              {
                text: 'Jarak Absen (Radius)',
                width: '200px',
                value: 'attended_range'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      reset(item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = !this.dialog.form ? true : false

        this.form = {
          id: item === undefined ? '' : item.id,
          name: item === undefined ? '' : item.name,
          latitude: item === undefined ? '' : item.latitude,
          longitude: item === undefined ? '' : item.longitude,
          attended_range: item === undefined ? '' : item.attended_range
        }

        this.process.form = false

        this.message.error = ''
      },
      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true
          
          await post(`admin/office/update`, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>